/**
 * Warms browser cache for main product gallery images (main-product section only),
 * one browser-chosen size per image.
 * Runs after first hero image loads or on idle — does not block initial render.
 */
(function () {
  var VIDEO_RE = /\.(mp4|webm|m3u8|mov)(\?|#|$)/i;

  function isLikelyVideoUrl(url) {
    return VIDEO_RE.test(url || '');
  }

  /*
   * Każde zdjęcie galerii pobiera się raz, w rozmiarze, który przeglądarka sama wybierze z srcset
   * (szerokość ekranu × gęstość pikseli). Wcześniej pobierały się wszystkie rozmiary z srcset naraz
   * (8 plików na zdjęcie) — kilka MB na telefonie.
   */
  function preloadGalleryImages(root) {
    if (!root) return;

    root.querySelectorAll('[id^="Slider-Gallery"] img').forEach(function (img) {
      if (img.getAttribute('loading') === 'lazy') img.setAttribute('loading', 'eager');

      var dataSrc = img.getAttribute('data-src');
      if (dataSrc && !img.getAttribute('src') && !isLikelyVideoUrl(dataSrc)) {
        var preloadImg = new Image();
        preloadImg.decoding = 'async';
        preloadImg.src = dataSrc;
      }
    });
  }

  function runPreload() {
    var section = document.querySelector('section[id^="MainProduct-"]');
    if (!section) return;
    preloadGalleryImages(section);
  }

  function scheduleIdle() {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(runPreload, { timeout: 1500 });
    } else {
      setTimeout(runPreload, 800);
    }
  }

  function scheduleProductGalleryPreload() {
    var section = document.querySelector('section[id^="MainProduct-"]');
    if (!section) return;

    var firstImg = section.querySelector('[id^="Slider-Gallery"] img');
    var started = false;

    function startOnce() {
      if (started) return;
      started = true;
      scheduleIdle();
    }

    if (firstImg && !firstImg.complete) {
      firstImg.addEventListener('load', startOnce, { once: true });
      firstImg.addEventListener('error', startOnce, { once: true });
      setTimeout(startOnce, 4000);
    } else {
      startOnce();
    }
  }

  document.addEventListener('ajax:loaded', scheduleProductGalleryPreload);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleProductGalleryPreload);
  } else {
    scheduleProductGalleryPreload();
  }
})();
